import { navigate } from '@reach/router'
import { Link } from 'gatsby'
import React from 'react'
import './index.css'

const externalProps = {
  target: '_blank',
  rel: 'noopener noreferrer',
} as const

type TouchableProps = {
  children?: React.ReactNode
  className?: string
  disabled?: boolean
  external?: boolean
  onClick?: (e: React.MouseEvent) => void
  scrollToMainContent?: boolean
  style?: React.CSSProperties
  tag?: 'a' | 'button'
  to?: string
  type?: 'button' | 'submit' | 'reset'
}

export const Touchable = ({
  children,
  className = '',
  disabled,
  external,
  onClick,
  scrollToMainContent = false,
  tag,
  to,
  type,
  ...props
}: TouchableProps) => {
  const rootClassName = `Touchable--root ${className}`

  if (disabled) {
    return (
      <button
        className={rootClassName}
        tabIndex={-1}
        type="button"
        {...props}
      >
        {children}
      </button>
    )
  }

  if (tag === 'a' || external) {
    return (
      <a
        href={to}
        className={rootClassName}
        onClick={onClick}
        {...(external ? externalProps : {})}
        {...props}
      >
        {children}
      </a>
    )
  }

  if (tag === 'button' || type) {
    return (
      <button
        className={rootClassName}
        type={type ?? 'button'}
        onClick={onClick}
        {...props}
      >
        {children}
      </button>
    )
  }

  if (!to) {
    return (
      <button
        className={rootClassName}
        type="button"
        onClick={onClick}
        {...props}
      >
        {children}
      </button>
    )
  }

  return (
    <Link
      className={rootClassName}
      onClick={(e) => {
        e.preventDefault()
        const page = document.getElementById('outer-container')
        if (scrollToMainContent) {
          const container = document.getElementsByClassName('Layout--container')[0] as HTMLElement | undefined
          if (container && page) {
            page.scrollTop = container.offsetTop
          }
        } else if (page) {
          page.scrollTop = 0
        }
        void navigate(to)
        onClick?.(e)
      }}
      to={to}
      {...props}
    >
      {children}
    </Link>
  )
}
